import { ApolloError } from "@apollo/client";
import { Layout } from "../../UI/Layout/Layout.tsx";
import { ScreenTitleBlock } from "../../UI/Layout/ScreenTitleBlock.tsx";
import { Card } from "../../UI/Card.tsx";
import { useMessagePopupController } from "../../UI/MessagePopup/useMessagePopupController.ts";
import { ErrorMessagePopup } from "../../UI/MessagePopup/ErrorMessagePopup.tsx";
import { BreadCrumbsWrapper } from "../../UI/Layout/BreadCrumbsWrapper.tsx";
import { BreadCrumbsItem } from "../../UI/Layout/BreadCrumbsItem.tsx";
import { useToCoursePdfs } from "../../CoursePdf/useToCoursePdfs.ts";
import {
  OnboardingLivePdfForm,
  OnboardingLivePdfFormInputs,
} from "./OnboardingLivePdfForm.tsx";
import { useOnboardingLivePdfs } from "./useOnboardingLivePdfs.ts";
import { useUserGroupsMissingOnboardingLivePdf } from "./useUserGroupsMissingOnboardingLivePdf.ts";

export function CreateOnboardingLivePdfScreen() {
  const { upsertPdf } = useOnboardingLivePdfs();
  const userGroupsMissingPdf = useUserGroupsMissingOnboardingLivePdf();
  const { toCoursePdfs } = useToCoursePdfs();
  const { show, title, description, showPopup } = useMessagePopupController(
    4 * 1000,
  );

  async function onSave(input: OnboardingLivePdfFormInputs) {
    try {
      await upsertPdf(input.userGroupId, input.pdfUrl);
    } catch (e) {
      const error = e as ApolloError;
      showPopup("Error", error?.message ?? "Unknown error");
      return;
    }
    toCoursePdfs();
  }

  return (
    <>
      <ErrorMessagePopup title={title} description={description} show={show} />
      <Layout>
        <Card>
          <ScreenTitleBlock
            title={"New Onboarding Live PDF"}
            breadCrumbs={
              <BreadCrumbsWrapper>
                <BreadCrumbsItem title={"Course PDFs"} onClick={toCoursePdfs} />
                <BreadCrumbsItem title={"New"} />
              </BreadCrumbsWrapper>
            }
          />
        </Card>
        <div className={"mt-4"}>
          <Card>
            <OnboardingLivePdfForm
              userGroups={userGroupsMissingPdf}
              onSave={onSave}
            />
          </Card>
        </div>
      </Layout>
    </>
  );
}
